<form class="flex flex-col gap-4" [formGroup]="form" (ngSubmit)="submit()">
  <p-floatlabel variant="on" class="mt-1.5">
    <generic-dropdown
      class="w-full"
      [items]="builderReferences()"
      [label]="''"
      formControlName="builderReference"
      [allowSearch]="true"
      [clearable]="false"
      [required]="true"
      [errormessage]="'Builder Reference is required'"
      placeholder=""
    />
    <label>Builder Reference <span class="text-red-500">*</span></label>
  </p-floatlabel>
  <div class="flex justify-end gap-2">
    <p-button label="Cancel" severity="secondary" type="button" (onClick)="close()" />
    <p-button label="Add Addendum" type="submit" [loading]="isSubmitting()" />
  </div>
</form>
